var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3334 17.8822C38.3334 20.7476 37.4837 23.376 36.0213 25.5696C33.887 28.7315 30.5077 30.9646 26.5751 31.5376C25.9032 31.6562 25.2115 31.7155 24.5001 31.7155C23.7887 31.7155 23.097 31.6562 22.4251 31.5376C18.4925 30.9646 15.1132 28.7315 12.9789 25.5696C11.5165 23.376 10.6667 20.7476 10.6667 17.8822C10.6667 10.2343 16.8522 4.04883 24.5001 4.04883C32.1479 4.04883 38.3334 10.2343 38.3334 17.8822Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7796 36.5972L39.5189 37.3679C38.7877 37.5458 38.2146 38.0992 38.0565 38.8303L37.3649 41.7353C36.9894 43.3163 34.9737 43.7906 33.9263 42.5456L24.4999 31.716L15.0734 42.5653C14.026 43.8103 12.0103 43.336 11.6349 41.7551L10.9432 38.8501C10.7653 38.1189 10.1922 37.5458 9.48081 37.3877L6.22009 36.617C4.71819 36.2613 4.18462 34.3839 5.27152 33.297L12.9787 25.5898C15.1129 28.7517 18.4922 30.9849 22.4249 31.558C23.0968 31.6765 23.7884 31.7358 24.4999 31.7358C25.2113 31.7358 25.903 31.6765 26.5749 31.558C30.5075 30.9849 33.8868 28.7517 36.021 25.5898L43.7282 33.297C44.8151 34.3641 44.2815 36.2415 42.7796 36.5972Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6463 11.9144L26.8123 14.2463C26.9704 14.5625 27.3854 14.8787 27.7608 14.938L29.8754 15.2937C31.2192 15.511 31.5354 16.4991 30.567 17.4675L28.9268 19.1077C28.6501 19.3844 28.492 19.918 28.5908 20.3132L29.0651 22.3487C29.4406 23.9494 28.5908 24.5817 27.168 23.732L25.1918 22.566C24.8361 22.3486 24.2432 22.3486 23.8875 22.566L21.9113 23.732C20.4885 24.562 19.6387 23.9494 20.0142 22.3487L20.4885 20.3132C20.5675 19.9377 20.4292 19.3844 20.1525 19.1077L18.5123 17.4675C17.5439 16.4991 17.8601 15.5308 19.2039 15.2937L21.3185 14.938C21.6742 14.8787 22.0892 14.5625 22.2473 14.2463L23.4132 11.9144C23.9863 10.6496 25.0139 10.6496 25.6463 11.9144Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalStarIcon);
export default __webpack_public_path__ + "static/media/medal-star-icon.560a418f123b4f651c437f4325f720e2.svg";
export { ForwardRef as ReactComponent };